import mixins from 'vue-typed-mixins'
import MediaModalMixin from '@/mixins/MediaModalMixin'
import UserActionMixin from '@/mixins/UserActionMixin'

export default mixins(MediaModalMixin, UserActionMixin).extend({
  data() {
    return {
      $_isIineProcessing: false
    }
  },
  computed: {
    $_isDetailMode(): boolean {
      const isRouteTimelineDetail = this.$route.name === 'timeline/detail'
      if (this.$store.getters.UA_IS_ANDROID) {
        return /#\/timeline\/[\d]+\/[\d]+$/.test(location.hash)
      }
      return isRouteTimelineDetail
    }
  },
  methods: {
    /**
     * 名前やアイコンなどをクリック
     */
    async $_handleAccountClick(data: any, index: number) {
      if (this.$_isDetailMode) {
        this.$_jumpToProfile(data)
      } else {
        this.$store.commit('TimelineUser/setName', data.name)
        this.$store.commit('TimelineUser/setUserId', data.user_id)
        this.$router.push({
          name: 'timeline/user',
          params: {
            user_id: data.user_id,
            name: data.name
          }
        })
      }
    },

    /**
     * タイムラインいいねのトグル処理
     */
    async $_handleIineToggle(data: any, index: number) {
      if (data.is_premier && !data.bought) {
        this.$_alert('有料記事にいいねできるのは購入者だけです。')
        return
      }
      if (this.$_isIineProcessing) {
        return
      }

      this.$_isIineProcessing = true

      try {
        const resData = await this.$store.dispatch('Timeline/toggleIine', {
          entry: data,
          index
        })
        if (resData.error) {
          this.$_alert(resData.error)
          this.$_isIineProcessing = false
          return
        }

        this.$emit('update', index)

        return resData
      } catch (err) {
        console.error(err)
      } finally {
        this.$_isIineProcessing = false
      }
    },

    /**
     * Media ファイルのクリック処理
     * 未購入なら購入ダイアログ、購入済みなら MediaModal を表示
     */
    async $_handleMediaClick(data: any, index: number) {
      if (data.bought || data.own || !data.is_premier) {
        const menus = data.own ? [''] : ['download']

        this.$_showMediaModal({
          menus: menus,
          mediaUrl: data.media_url,
          mediaType: data.media_type,
          mediaThumbnail: data.media_thumbnail,
          savePhotoPoint: this.$store.getters['Timeline/savePhotoPoint'],
          saveVideoPoint: this.$store.getters['Timeline/saveVideoPoint'],
          requestUrl: '/timeline/',
          requestParams: {
            t_id: data.t_id
          }
        })
      } else if (data.is_premier && !data.own) {
        let buyPoint = ''
        let typeLabel = ''
        if (data.media_type === 'photo') {
          buyPoint = this.$store.getters['Timeline/buyPhotoPoint']
          typeLabel = '写真'
        } else if (data.media_type === 'video') {
          buyPoint = this.$store.getters['Timeline/buyVideoPoint']
          typeLabel = '動画'
        }

        // 購入確認
        const buttonIndex = await this.$_confirm(
          `${buyPoint}ptsを使ってこの${typeLabel}を閲覧しますか？`,
          `${typeLabel}の閲覧`,
          ['キャンセル', `${typeLabel}を見る`]
        )
        if (!this.$_clickedConfirmOK(buttonIndex)) {
          return
        }

        const res = await this.$http.post('/timeline/', {
          page: 'buy',
          t_id: data.t_id
        })
        const error = res.data.error
        if (error) {
          if (error.code === '9') {
            await this.$_showPointBuyDialog(error.description, error.message)
          } else {
            this.$_alert(error.description, error.message)
          }
          return
        }

        // 購入に成功したならファイルの URL と購入済みフラグを書き換え
        data.bought = true
        data.media_url = res.data.media_url
        if (data.media_type === 'video') {
          data.media_thumbnail = res.data.media_thumbnail
        }
        this.$store.commit('Timeline/setEntry', {
          entry: data,
          index: index
        })

        this.$emit('update', index)
      }
    },

    /**
     * 自分の投稿の削除
     */
    async $_handleTweetRemove(tId: string, index: number, message?: string) {
      if (!message) {
        message = 'この投稿を削除してもよろしいですか？'
      }
      const buttonIndex = await this.$_confirm(message, '', ['キャンセル', '削除する'])
      if (!this.$_clickedConfirmOK(buttonIndex)) {
        return
      }
      const data = await this.$store.dispatch('Timeline/remove', {
        id: tId,
        entryKey: index
      })
      const error = data.error
      if (error) {
        if (typeof error === 'string') {
          this.$_alert(error)
        } else if (error.message) {
          this.$_alert(error.description, error.message)
        }
        return
      }
      this.$_alert('削除しました')

      // 削除の場合は update 通知を送る必要なし

      if (this.$_isDetailMode || this.$route.name === 'timeline/post') {
        this.$router.back()
      }
    },

    /**
     * 自分以外ならプロフにジャンプ
     */
    $_jumpToProfile(data) {
      if (data.own && this.$route.name !== 'user') {
        // 自分のプロフにはアクセスしない
        this.$router.push(`/user/${data.user_id}`)
      }
    }
  }
})
